import React from 'react';

import NoResultsMessage from '../../../../components/NoResultsMessage';
import SearchSimpleTable from '../../../../components/search/SearchSimpleTable';
import noInsuredsImage from '../../../../noInsuredsImage.png';
import { insuredListSearch } from '../../../../redux/modules/insuredList';
import InsuredListRow from '../InsuredListRow';

const mapper = insured => <InsuredListRow insured={insured} key={insured.id} />;

function InsuredsPageBody() {
  const noResults = () => (
    <NoResultsMessage
      altTag="No Insureds"
      dusk="no-insureds"
      image={noInsuredsImage}
      message="Nothing to see here."
      subText="Add an insured to get started."
    />
  );

  return (
    <SearchSimpleTable
      dataMapper={mapper}
      height="77vh"
      minHeight="300px"
      noResultsComponent={noResults}
      searchBlueprint={insuredListSearch}
    />
  );
}

export default InsuredsPageBody;
